import React from 'react';
import { pageUrlService } from '@shared/services/pageUrlService';
import { userPrivileges } from '@apollo-internal/cache';
import PrivilegeNames from '../../../../../constants/privilegeNames';
import { useReactiveVar } from '@apollo/client';
import RecentUpdatesNotificationCard from '../RecentUpdatesNotificationCard';

/**
 * @typedef {object} ReappraisalRationaleNotificationProps
 * @property {Object} [notification]
 */

/**
 * @param {ReappraisalRationaleNotificationProps} props
 */
const ReappraisalRationaleNotification = props => {
  const { notification } = props;

  const privileges = useReactiveVar(userPrivileges);

  const canAccessReappraisalRationaleReview = privileges.includes(
    PrivilegeNames.ReappraisalRationaleReview
  );

  const redirectUrl = canAccessReappraisalRationaleReview
    ? pageUrlService.getViewCheckpointReappraisalRationaleUrl(notification.CheckPoint.Id)
    : null;

  return (
    <RecentUpdatesNotificationCard
      name={notification.Name}
      label='Reappraisal Rationale has been submitted.'
      notificationDaysAgo={notification.NotificationDaysAgo}
      redirectUrl={redirectUrl}
    />
  );
};

export default ReappraisalRationaleNotification;
